import React from "react";
import { webstoredb } from "./db";
import "./style.css";
import { Button } from "../../Components/reusable_components";
import Navbar from "../../Components/Navbar";
function WebStore() {
  return (
    <div className="webstore">
      <Navbar />
      {webstoredb.map((item, i) => (
        <WebstoreContent data={item} key={i} />
      ))}
    </div>
  );
}

function WebstoreContent({ data }) {
  return (
    <div
      className="webstore_wrapper"
      style={{ padding: "10px", width: "80%", margin: "auto" }}
    >
      <h1>{data.title}</h1>
      <p>{data.desc}</p>
      <div className="image-slider">
        <div className="slider-wrapper">
          {data.images.map((item, i) => (
            <img src={item} alt="" key={i} className="slider-image" />
          ))}
        </div>
      </div>
      <Button value={"visit"} link={data.link} rel="noreferrer" />
    </div>
  );
}

export default WebStore;
